import { render, staticRenderFns } from "./store_detail.vue?vue&type=template&id=4f4a4622&scoped=true&"
import script from "./store_detail.vue?vue&type=script&lang=js&"
export * from "./store_detail.vue?vue&type=script&lang=js&"
import style0 from "./store_detail.vue?vue&type=style&index=0&id=4f4a4622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4a4622",
  null
  
)

export default component.exports